export const translations = {
  EN: {
    // Navigation translations (already existing)
    userPanel: "User Panel",
    adminPanel: "Admin Panel",
    welcome: "Welcome",
    signOut: "Sign out",
    signIn: "Sign in",
    darkMode: "Dark Mode",
    lightMode: "Light Mode",

    // Admin Panel translations
    userManagement: "User Management",
    modelManagement: "Model Management",
    createNewUser: "Create New User",
    createNewModel: "Create New Model",
    username: "Username",
    email: "Email",
    password: "Password",
    group: "Group",
    quota: "Quota",
    assignedModels: "Assigned Models",
    status: "Status",
    role: "Role",
    actions: "Actions",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    create: "Create",
    filter: "Filter",
    sortBy: "Sort by",
    ascending: "Ascending",
    descending: "Descending",
    noUsersFound: "No users found",
    noModelsFound: "No models found",
    failedToFetchDocuments: "Failed To Fetch Documents",
    uploadFailed: "Failed To Fetch Documents",
    uploadNewDocuments: "Upload New Documents",
    holdCtrlToSelect: "Hold Ctrl/Cmd to select multiple models",
    confirmDelete: "Are you sure you want to delete this?",
    usersSelected: "users selected",
    importUsers: "Import Users from CSV",
    modelName: "Model Name",
    commands: "Description",
    assignToSelected: "Assign to Selected",
    selected: "Selected",
    allRoles: "All Roles",
    usersOnly: "Users Only",
    adminsOnly: "Admins Only",
    users: "Users",
    admins: "Admins",
    createUser: "Create User",
    active: "Active",
    notActive: "Not active",
    passwordRequirements:
      "Password must contain at least 8 characters, including uppercase, lowercase, number and special character",

    // Import related
    selectFile: "Select File",
    importComplete: "Import Complete",
    importing: "Importing...",
    importFailed: "Import Failed",
    csvFormat: "Format: username;email (one per line)",
    preview: "Preview",
    normalizedUsername: "Normalized Username",
    originalUsername: "Original Username",
    normalizedEmail: "Normalized Email",
    originalEmail: "Original Email",
    successfulImport: "Successfully imported",
    outOf: "out of",
    existingUsernames: "Existing Usernames",
    otherErrors: "Other Errors",

    // User Panel translations
    availableModels: "Available Models",
    askQuestion: "Ask a Question",
    typeQuestion: "Type your question...",
    ask: "Ask",
    conversationHistory: "Conversation History",
    noConversations: "No conversations yet",
    noModelsAssigned: "No models assigned to your account",
    loading: "Loading...",
    error: "Error occurred",
    success: "Operation successful",
    none: "None",
    models: "Models",
    noFileSelected: "No file selected",
    authenticating: "Authenticating...",
    authError: "Authentication error",

    documentManagement: "Source docs",
    uploadedDocuments: "Source docs",
    noDocumentsUploaded: "No files yet",
    deleteFailed: "Delete Failed",
    confirmDocumentDeletion: "Confirm Document Deletion",

    onlyPdfAndTxtSupported: "Only PDF and TXT files are supported",
    uploadingFiles: "Uploading files...",
    uploadFiles: "Upload Files",
    selectFiles: "Select Files to model",
  },
  PL: {
    // Navigation translations (already existing)
    userPanel: "Panel Użytkownika",
    adminPanel: "Panel Admina",
    welcome: "Witaj",
    signOut: "Wyloguj",
    signIn: "Zaloguj",
    darkMode: "Tryb Ciemny",
    lightMode: "Tryb Jasny",

    // Admin Panel translations
    userManagement: "Zarządzanie Użytkownikami",
    modelManagement: "Zarządzanie Modelami",
    createNewUser: "Utwórz Nowego Użytkownika",
    createNewModel: "Utwórz Nowy Model",
    username: "Nazwa Użytkownika",
    email: "Email",
    password: "Hasło",
    group: "Grupa",
    quota: "Limit",
    assignedModels: "Przypisane Modele",
    status: "Status",
    role: "Rola",
    actions: "Akcje",
    edit: "Edytuj",
    delete: "Usuń",
    save: "Zapisz",
    cancel: "Anuluj",
    create: "Utwórz",
    filter: "Filtruj",
    sortBy: "Sortuj po",
    ascending: "Rosnąco",
    descending: "Malejąco",
    noUsersFound: "Nie znaleziono użytkowników",
    noModelsFound: "Nie znaleziono modeli",
    failedToFetchDocuments: "Nie wczytano dokumentów",
    holdCtrlToSelect: "Przytrzymaj Ctrl/Cmd aby wybrać wiele modeli",
    confirmDelete: "Czy na pewno chcesz to usunąć?",
    usersSelected: "wybranych użytkowników",
    importUsers: "Importuj Użytkowników z CSV",
    modelName: "Nazwa Modelu",
    commands: "Opis",
    assignToSelected: "Przypisz do Wybranych",
    selected: "Wybrano",
    allRoles: "Wszystkie Role",
    usersOnly: "Tylko Użytkownicy",
    adminsOnly: "Tylko Administratorzy",
    users: "Użytkownicy",
    admins: "Administratorzy",
    createUser: "Utwórz Użytkownika",
    active: "Aktywny",
    notActive: "Nieaktywny",
    passwordRequirements:
      "Hasło musi zawierać co najmniej 8 znaków, w tym wielką i małą literę, cyfrę oraz znak specjalny",

    // Import related
    selectFile: "Wybierz Plik",
    importComplete: "Import Zakończony",
    importing: "Importowanie...",
    importFailed: "Import Nieudany",
    csvFormat: "Format: nazwa_użytkownika;email (jeden na linię)",
    preview: "Podgląd",
    normalizedUsername: "Znormalizowana Nazwa",
    originalUsername: "Oryginalna Nazwa",
    normalizedEmail: "Znormalizowany Email",
    originalEmail: "Oryginalny Email",
    successfulImport: "Pomyślnie zaimportowano",
    outOf: "z",
    existingUsernames: "Istniejące Nazwy Użytkowników",
    otherErrors: "Inne Błędy",

    // User Panel translations
    availableModels: "Dostępne Modele",
    askQuestion: "Zadaj Pytanie",
    typeQuestion: "Wpisz swoje pytanie...",
    ask: "Pytaj",
    conversationHistory: "Historia Konwersacji",
    noConversations: "Brak historii konwersacji",
    noModelsAssigned: "Brak przypisanych modeli do twojego konta",
    loading: "Ładowanie...",
    error: "Wystąpił błąd",
    success: "Operacja zakończona sukcesem",
    none: "Brak",
    models: "Modele",
    noFileSelected: "Nie wybrano pliku",
    authenticating: "Uwierzytelnianie...",
    authError: "Błąd uwierzytelniania",

    documentManagement: "Dokumenty źródłowe",
    uploadedDocuments: "Wczytane dokumenty",
    uploadNewDocuments: "Nowe dokumenty",
    noDocumentsUploaded: "Brak dokumentów",
    deleteFailed: "Nie skasowano",
    confirmDocumentDeletion: "Potwierdź usunięcie dokumentu",

    onlyPdfAndTxtSupported: "Tylko typy PDF i TXT są przyjmowane",
    uploadingFiles: "Wczytywanie plików...",
    uploadFiles: "Wczytaj pliki",
    selectFiles: "Wybierz pliki do modelu",
  },
};
